/**
 * Created by PuTi(编程即菩提) 2/20/17.
 */
var Page = require('./Page');
var Model = require('./model/Model');
var app = require('../../app');
var getPageData = require('../../io/' + process.env.APP_ENV + '/index/getPageData');
var config = require('./config');
app.start(Page, Model,getPageData,config);


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/shell.js
// module id = 503
// module chunks = 6